import { render, staticRenderFns } from "./sorelationview.vue?vue&type=template&id=82520ec6&scoped=true&"
import script from "./sorelationview.vue?vue&type=script&lang=js&"
export * from "./sorelationview.vue?vue&type=script&lang=js&"
import style0 from "./sorelationview.vue?vue&type=style&index=0&id=82520ec6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82520ec6",
  null
  
)

export default component.exports